import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function IdentificationSection() {
  return <section className="py-24 bg-white relative" data-id="element-122">
      <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-123">
        <FadeIn data-id="element-124">
          <p className="text-base md:text-lg font-serif italic text-charcoal-light mb-6" data-id="element-125">
            Esto no va a mejorar solo con el tiempo.{' '}
            <span className="font-semibold text-charcoal not-italic" data-id="element-126">
              Y no es tu culpa.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.05} data-id="element-127">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-10" data-id="element-128">
            Si estás aquí es porque algo cambió.
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-charcoal-light leading-relaxed" data-id="element-129">
          <FadeIn delay={0.1} data-id="element-130">
            <p data-id="element-131">
              De repente la ropa no te queda igual… la barriga apareció sin
              explicación… y las noches se convirtieron en un caos.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-132">
            <div className="p-8 rounded-2xl bg-cream-alt shadow-inner-warm border border-cream-dark/30" data-id="element-133">
              <p className="font-medium text-charcoal" data-id="element-134">
                Te despiertas a las 3 de la madrugada. No puedes volver a
                dormir. Y al día siguiente estás agotada.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-135">
            <h3 className="text-3xl md:text-4xl font-serif italic text-terracotta mt-12 mb-8" data-id="element-136">
              No estás loca. No estás fallando.
            </h3>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-137">
            <p className="font-medium" data-id="element-138">
              Tu cuerpo cambió… y nadie te explicó cómo adaptarte.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}